import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'
import FontAwesome from 'react-fontawesome'

import Box from '../Layout/Box'
import BoxSection from '../Layout/BoxSection'
import ModalConfirmarAccion from '../../components/Shared/ModalConfirmarAccion'
import ModalSelectorFromList from '../Shared/ModalSelectorFromList'
import SelectorInput from '../Shared/SelectorInput'

import { uniqueArray, isAllowedToViewComponent, romanize, formatcoin, getDivisa } from '../../utils/helpers';

import { 
    showModalConfirmarAccion,     
    showModalSelector,
    selectFromSelector,
    getParameterByName
} from '../../actions/common'

import {
    registerApprovalResult,
    updateInputs,
    crearAprobacionAdicional
} from '../../actions/solicitudservicioot'

class Aprobaciones extends Component {



    componentWillMount() {
        this.props.getParameterByName('SMMLV')
        this.props.getParameterByName('MATRIZ_APROBACION')
        this.props.getParameterByName('APROBADORES_ADICIONALES')
    }    


    constructor(props) {
        super(props);
        this.state = {
            solicitarAprobacionAdicional: false,
            aprobadorAdicional: null,
            motivoAprobacionAdicional: ''
        };
    }


    handleOpenSelectorAprobador = () => {
        const fields = [
            { id: 1, caption: 'Nombre', value: 'fullname', width: '40%' },
            { id: 2, caption: 'Cargo', value: 'cargo', width: '40%' },
            { id: 3, caption: 'Miembro', value: 'esmiembrocomite', width: '20%' }
        ];
        this.props.showModalSelector(
            'Seleccione aprobador adicional',
            fields,
            '/usuarios/aprobadores-adicionales',
            (aprobador) => {
                this.setState({ aprobadorAdicional: aprobador });
            }
        );
    }



    rubros = false;

    registerRubros = (index, value) => {
        this.props.solicitudservicioot.get('servicios').keySeq().forEach(k => 
            this.props.updateInputs(`solicitud.servicios.${k}.cencos.${index}.pivot.rubro_id`, value)
        )
    }

    approve = (tipo, indice, totalSevicios, cencos, m) => { 

        this.rubros = false

        if (tipo == 1) {
            //this.rubros = true
        }

        this.props.showModalConfirmarAccion(true, 
            `Al hacer click en Ok, estará aprobando el cargue de ${formatcoin((totalSevicios),m)} ${cencos.length > 1 ? 'entre los ' : 'al'} 
            centro${cencos.length > 1 ? 's' : ''} de costo ${uniqueArray(cencos).join(', ') }
            ${this.props.solicitudservicioot.get('tipo') == 5 ? `y con la fecha de entrega ${moment(this.props.solicitudservicioot.get('fecha_requerido')).format('DD/MM/YYYY')} `: '' }`,
            () => { this.props.showModalConfirmarAccion(false); this.props.registerApprovalResult(indice, 2)})
    }
    
    
    reject = (indice) => {
        this.rubros = false;
        this.props.showModalConfirmarAccion(true, `¿Está seguro que desea rechazar esta solicitud?`, () => { this.props.showModalConfirmarAccion(false); this.props.registerApprovalResult(indice, 0)})
    }


    showApproval = (aprobador_id) => {

        let showApproval = true;
        
        const aprobaciones = this.props.solicitudservicioot.getIn(['cotizaciones','0','aprobaciones']);
        const aprobacion = aprobaciones.filter(a => a.get('aprobador_id') === aprobador_id).first();

        if (aprobacion.get('estado') === 1 && !this.props.user.get('es_superusuario')) {
            const aprobaciones_requeridas = aprobaciones.filter(a => a.getIn(['aprobador', 'reporta_a_id']) === aprobador_id &&  a.get('aprobador_id') !== a.getIn(['aprobador', 'reporta_a_id']));
            showApproval = aprobaciones_requeridas.filter(a => a.get('estado') === 1).count() === 0;
        } 

        return showApproval;

    }


	handleEnviarSolicitudAdicional = () => {
        const { aprobadorAdicional, motivoAprobacionAdicional } = this.state;
        if (!aprobadorAdicional || !motivoAprobacionAdicional.trim()) {
            return;
        }
        this.props.crearAprobacionAdicional(aprobadorAdicional, motivoAprobacionAdicional);
        this.setState({
            solicitarAprobacionAdicional: false,
            aprobadorAdicional: null,
            motivoAprobacionAdicional: ''
        });
    }



    tipo_corte = () => {

        const { smmlv, matriz_aprobacion, solicitudservicioot } = this.props

        let tipoAprobacion = 1

        const cotizacion = solicitudservicioot.getIn(['cotizaciones', 0]);
        const trm = cotizacion ? Number(cotizacion.get('trm')) : 1;     
        const cotizadoIva = cotizacion ? Number(cotizacion.get('cotizado_iva')) : 0;   

        const totalSMMLV = (smmlv && ((cotizadoIva * trm) / parseFloat(smmlv.first().get('SMMLV')))) || 0;

        const match = matriz_aprobacion && matriz_aprobacion.find(item =>
            parseFloat(item.get('DESDE_SMMLV')) <= totalSMMLV && totalSMMLV < parseFloat(item.get('HASTA_SMMLV'))
        );

        if (match) {
            tipoAprobacion = match && parseInt(match.get('TIPO_APROBACION')) || 1;
        }

        return tipoAprobacion;
        
    }   
    
    
    info_aprobador_adicional = (aprobador) => {
        const { aprobadores_adicionales } = this.props;
        if (!aprobador) return null;
        if (!aprobadores_adicionales) return null;
        const aprobadorInfo = aprobadores_adicionales.find(a => a.get('USUARIO') === aprobador.get('username'));
        if (!aprobadorInfo) return null;
        return {
            cargo: aprobadorInfo.get('CARGO') || 'Sin cargo',
            esmiembrocomite: aprobadorInfo.get('MIEMBRO_COMITE') === 'SI'
        };
    }

	render() {
        
        const { id, solicitudservicioot, enums, btnAproveDisabled, divisas } = this.props
        if (!id) return null

        const moneda = solicitudservicioot.getIn(['cotizaciones',0,'moneda'])
        const divisa = getDivisa(divisas, moneda)

        const totalSevicios = solicitudservicioot.get('servicios').reduce((a, b) => {
            a += b.get('valor_con_iva')
            return a
        }, 0)

		return (
            <div>
                {this.tipo_corte() === 1 && solicitudservicioot.get('estado') == 3 && (
                    <BoxSection title="Aprobación adicional">
                        <div className="row">
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={this.state.solicitarAprobacionAdicional}
                                            onChange={e => this.setState({ solicitarAprobacionAdicional: e.target.checked })}
                                        />
                                        <span style={{marginLeft: '7px'}}>Solicitar aprobación adicional</span>
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-3">
                                {this.state.solicitarAprobacionAdicional && (
                                    <div className="form-group">
                                        <label className="control-label">Seleccione aprobador adicional</label>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <SelectorInput 
                                                value={this.state.aprobadorAdicional ? this.state.aprobadorAdicional.fullname : ''} 
                                                onClick={this.handleOpenSelectorAprobador}
                                                onReset={ () => this.setState({ aprobadorAdicional: null }) }
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                            {this.state.solicitarAprobacionAdicional && this.state.aprobadorAdicional && (
                                <Fragment>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label className="control-label">Cargo del aprobador:</label>
                                            <div className="form-control input-sm" style={{ background: '#f9f9f9', paddingTop: '5px' }}>
                                                {this.state.aprobadorAdicional.cargo || 'Sin cargo'}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3" style={{ display: 'flex', alignItems: 'center', marginTop: 25 }}>
                                        {this.state.aprobadorAdicional.esmiembrocomite === 'SI' && (
                                            <span className="label label-success" style={{ fontSize: 13 }}>
                                                Integrantes del Comité de Rectoría
                                            </span>
                                        )}
                                    </div>
                                </Fragment>
                            )}
                        </div>
                        <div>
                            {this.state.solicitarAprobacionAdicional && this.state.aprobadorAdicional && (
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="control-label">Motivo de la solicitud adicional</label>
                                            <textarea 
                                                rows={3} 
                                                className="form-control input-sm" 
                                                value={this.state.motivoAprobacionAdicional}
                                                onChange={e => this.setState({ motivoAprobacionAdicional: e.target.value })} 
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {this.state.solicitarAprobacionAdicional && this.state.aprobadorAdicional && (
                            <div className="row">
                                <div className="col-md-12" style={{ textAlign: 'right', paddingTop: '10px', paddingBottom: '10px' }}>
                                    <button
                                        className="btn btn-primary btn-sm"
                                        disabled={
                                            !this.state.motivoAprobacionAdicional.trim() ||
                                            !this.state.aprobadorAdicional
                                        }
                                        onClick={this.handleEnviarSolicitudAdicional}
                                    >
                                        Enviar solicitud adicional
                                    </button>
                                </div>
                            </div>
                        )}

                    </BoxSection>
                )}
                <div style={{ marginBottom: '20px' }}></div>
                {
                    (solicitudservicioot.getIn(['cotizaciones','0','aprobaciones']).count() > 0 && solicitudservicioot.getIn(['cotizaciones','0','aprobaciones']).map((a, b) => {
                        const cencos = []
                        if (!this.showApproval(a.get('aprobador_id'))) return;


                        const info_aprobador_adicional = this.info_aprobador_adicional(a.getIn(['aprobador']));

                        return [
                            (b > 0) ? <div key={ `sep1[${b}]` } className="separator" /> : null,


                            <BoxSection key={ `bs1[${a.get('id')}]` } title={
                                <span>
                                    { a.get('estado') === 2 ? <FontAwesome name="check" style={{ color: 'green' }} /> : a.get('estado') === 0 ? <FontAwesome name="times"  style={{ color: 'red' }}/> : '' }
                                    {a.get('tipo') === 3 ? (
                                        <span style={{ color: '#fff', fontWeight: 600 }}>
                                            Solicitud de aprobación adicional a <strong>{ a.getIn(['aprobador', 'fullname']) }</strong>
                                        </span>
                                    ) : (
                                        <Fragment>Solicitud de aprobación nivel { romanize(a.get('tipo')) } a <strong>{ a.getIn(['aprobador', 'fullname']) }</strong></Fragment>
                                    )}
                                </span>
                            }>
                                {info_aprobador_adicional && (
                                    <div className="row">
                                        <div className="col-md-12">
                                            <span style={{ fontWeight: 500 }}>
                                                Cargo: {info_aprobador_adicional.cargo || 'Sin cargo'}
                                            </span>
                                            {info_aprobador_adicional.esmiembrocomite ? (
                                                <span className="label label-success" style={{ marginLeft: 10 }}>
                                                    Integrantes del Comité de Rectoría
                                                </span>
                                            ) : null}
                                        </div>
                                    </div>
                                )}
                                <div className="row">
                                    <div className="col-md-12">

                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h4>Solicitud de aprobación: { enums.aprobaciones.estados[a.get('estado')] }{ a.get('estado') === 1 ? '' : <span> &bull; { moment(a.get('fecha')).format('YYYY-MM-DD HH:mm') }</span> }</h4>
                                    </div>
                                </div>
                                {                   
                                    a.get('aprobador_su') && (
                                        <div className="row">
                                            <div className="col-md-12">
                                                <span>Esta solicitud fue aprobada por <b>{ a.getIn(['aprobador_su', 'fullname']) }</b></span>                                                
                                            </div>
                                        </div>                                        
                                    )
                                }

                                <div className="row">
                                    <div className="col-md-12">
                                        <span>Solicitada por <b>{ solicitudservicioot.getIn(['solicitante', 'fullname']) }</b></span> &bull; <span><a href={ `mailto:${solicitudservicioot.getIn(['solicitante', 'email'])}` }>{ solicitudservicioot.getIn(['solicitante', 'email']) }</a></span>
                                    </div>
                                </div>

                                {
                                    solicitudservicioot.get('tipo') == 5 && <div className="row">
                                        <div className="col-md-12">
                                            <span>Fecha de entrega: </span><b>{moment(solicitudservicioot.get('fecha_requerido')).format('DD/MM/YYYY')}</b>
                                        </div>
                                    </div>
                                }

                                <div key={ `sep3[${b}]` } className="separator" />

                                <div className="row">
                                    <div className="col-md-12">
                                        <b>Detalle:</b>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <table className="table table-bordered table-condensed table-striped">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '50%' }}>Servicio</th>
                                                    <th style={{ width: '10%' }}>Cotización</th>
                                                    <th style={{ width: '40%' }}>Distribución</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    solicitudservicioot.getIn(['cotizaciones', '0', 'servicios']).map((c, d) => {
                                                        return (
                                                            <tr key={ `tr1[${a.get('id')}][${c.get('id')}]` }>
                                                                <td>{ c.get('descripcion') }</td>
                                                                <td style={{ textAlign: 'right' }}>{ formatcoin((c.get('valor_con_iva')),divisa.simbolo) }</td>
                                                                <td style={{ padding: 0 }}>
                                                                    <table className="table table-bordered table-condensed">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Cenco</th>
                                                                                <th>Rubro</th>
                                                                                <th>Porcentaje</th>
                                                                                <th>Valor</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                c.get('cencos').filter(e => a.get("tipo") == 1 ? (e.get('responsable_id') === a.getIn(['aprobador', 'id']) || e.getIn(['pivot', 'aprobador_id']) === a.getIn(['aprobador', 'id'])) : true).map((e, f) => {
                                                                                    cencos.push(e.get('codigo'))
                                                                                    return (
                                                                                        <tr key={ `tr2[${a.get('id')}][${c.get('id')}][${e.get('id')}]` }>
                                                                                            <td><span title={ `${e.get('descripcion')}` }>{ e.get('codigo') }</span></td>
                                                                                            <td><span title={ `${e.getIn(['pivot', 'rubro', 'descripcion'])}` }>{ e.getIn(['pivot', 'rubro', 'nombre']) }</span></td>
                                                                                            <td style={{ textAlign: 'right' }}>{ numeral(e.getIn(['pivot', 'porcentaje']) / 100).format('0.0%') }</td>
                                                                                            <td style={{ textAlign: 'right' }}>{ formatcoin(((e.getIn(['pivot', 'porcentaje']) / 100) * c.get('valor_con_iva')),divisa.simbolo) }</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {
                                    (a.get('estado') !== 1 &&
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="control-label">Observaciones</label>
                                                    <div className="form-control input-sm" style={{ height: '60px', overflowX: 'hidden' }}>
                                                        { a.get('observaciones') || '' }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                                    
                                    )
                                }
                                {
                                    (isAllowedToViewComponent('aprobacion', a) && 
                                        <div> 

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label className="control-label">Observaciones</label>
                                                        <textarea rows={6} className="form-control input-sm" value={ a.get('observaciones') || '' } onChange={ (e) => this.props.updateInputs(`solicitud.cotizaciones.0.aprobaciones.${b}.observaciones`, e.target.value) } disabled={a.get('tipo') === 3}/>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div style={{ textAlign: 'right', padding: '10px 0' }}>
                                                        <span>
                                                            <button 
                                                            className="btn btn-primary btn-sm btn-squared" 
                                                            onClick={ e => this.approve(a.get('tipo'), b, totalSevicios, cencos, divisa.simbolo) } disabled={ btnAproveDisabled }>Aprobar</button>
                                                        </span>
                                                        <span style={{ marginLeft: '10px' }}>
                                                            <button className="btn btn-default btn-sm btn-squared" onClick={ e => this.reject(b) } disabled={ btnAproveDisabled }>Rechazar</button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </BoxSection>
                        ]
                    }))
                }

                <ModalConfirmarAccion>
                {this.rubros && (                    
                    <div className="row">
                        <div className="col-md-12">
                            <Box title="Selección de rubros" onModal>
                                <div className="box-content" style={{ height: '81px', overflowX: 'hidden' }}>
                                    <table className="table table-condensed">
                                        <tbody>
                                            {
                                                this.props.solicitudservicioot.getIn(['servicios', '0', 'cencos']).map((x, n) => {
                                                    if (x.get('rubros').count() > 0) {
                                                        return (
                                                            <tr key={ `tr[${x.get('id')}]` }>
                                                                <td style={{ width: '20px', verticalAlign: 'middle' }} ><span>{ n + 1 }</span></td>
                                                                <td style={{ width: '55%' }} ><input type="text" className="form-control input-sm" value={ x.get('descripcion') ? x.get('descripcion') : '' } disabled /></td>
                                                                <td style={{ width: '45%' }}>
                                                                    <select className="form-control input-sm" value={ Number(x.getIn(['pivot', 'rubro_id'])) || 0 } onChange={ (e) => { this.registerRubros(n, Number(e.target.value)) } }>
                                                                        <option value={ 0 } disabled>Seleccione una opción</option>
                                                                        {x.get('rubros').map((r,j) => {
                                                                            return(
                                                                                <option key={`optr[${j}]`} value={r.get('id')}>{r.get('nombre')}</option>
                                                                            )
                                                                        })}
                                                                    </select>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </Box>
                        </div>
                    </div>
                )}
                </ModalConfirmarAccion>
                <ModalSelectorFromList />

            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        id: state.solicitudservicioot.get('id'),
        solicitudservicioot: state.solicitudservicioot.get('solicitud'),
        enums: state.common.get('enums').toJS(),
        user: state.common.get('user'),
        btnAproveDisabled: state.solicitudservicioot.get('btnAproveDisabled'),
        divisas: state.common.getIn(['parametros', 'DIVISAS']),
        smmlv: state.common.getIn(['parametros', 'SMMLV']),
        matriz_aprobacion: state.common.getIn(['parametros', 'MATRIZ_APROBACION']),
        aprobadores_adicionales: state.common.getIn(['parametros', 'APROBADORES_ADICIONALES']),
    }
}





function mapDispatchToProps(dispatch) {
    return {
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
        registerApprovalResult: (index, result) => dispatch(registerApprovalResult(index, result)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        crearAprobacionAdicional: (aprobadorAdicional, motivoAprobacionAdicional) => dispatch(crearAprobacionAdicional(aprobadorAdicional, motivoAprobacionAdicional)),
        getParameterByName: (param) => dispatch(getParameterByName(param)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Aprobaciones)


// WEBPACK FOOTER //
// ./src/components/SolicitudServicioOT/Aprobaciones.jsx